import { Icon } from '#/components/ui/icons';

interface DetailPrintButtonProps {
  /** GTM `data-track` id, forwarded onto the button. */
  dataTrack?: string;
  /** GTM `data-track-context`, forwarded onto the button. */
  dataTrackContext?: string;
}

export function DetailPrintButton({
  dataTrack,
  dataTrackContext,
}: DetailPrintButtonProps = {}) {
  return (
    <button
      type="button"
      data-track={dataTrack}
      data-track-context={dataTrackContext}
      className="mdc-print-hidden text-static-16 text-fg-strong hover:text-link-fg-hover focus-visible:outline-button-primary-bg inline-flex items-center gap-12 py-8 transition-colors focus-visible:outline-2 focus-visible:outline-offset-2"
      onClick={() => window.print()}
    >
      <Icon id="download" size="20" className="text-blue-60" />
      <span>Download as PDF</span>
    </button>
  );
}
